function ImageView({src}){

    return(
    <>
   <img src={src}/>
  </>);

}

export default ImageView;